import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import makeRequest from 'utils/makeRequest';
import { UNIFIED_VIDEO_DOMAIN_SERVICE } from 'constants';
import InViewObserver from 'components/InViewObserver';
import { addNextVideoMsid } from 'routes/home/redux';
import Video from 'components/Video/VideoLoader';
import NewStoryCard from 'components_v2/desktop/NewStoryCard';
import NewStoryMobileCard from 'components_v2/mobile/NewStoryCard';
import Morebtn from 'components_v2/mobile/Morebtn';
import Listingheader from '../../common/ListingheaderV2';
import HeaderTab from '../HeaderTabV2/HeaderTab';
import s from './VideoLayout.scss';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder/InterSectionBorder';
import LoaderSpinner from '../../../../../components_v2/common/LoaderSpinner/LoaderSpinner';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

const VideoLayout = ({
  sectionData = {},
  isEtimesVideo,
  isUserPrime,
  isVideoSkipAds,
  isMobile,
  className,
  // showVideoSectionLoader,
  // loadAjaxSectionData,
  // eslint-disable-next-line no-shadow
  addNextVideoMsid,
}) => {
  const videoListRef = useRef(null);
  const [slikeNextVideoAutoPlayed, setSlikeNextVideoAutoPlayed] = useState(
    false,
  );
  const [activeVideo, setActiveVideo] = useState({});
  const [nextTabVideos, setNextTabVideos] = useState([]);
  const [showLoader, setLoader] = useState(false);
  const [shareUrl, setShareUrl] = useState('');
  // const store = useContext(React.createContext(null));
  const [navigation, setNavigation] = useState({});
  const [showAllVideos, setShowAllVideos] = useState(false);

  const videoItems =
    !!nextTabVideos && Array.isArray(nextTabVideos) && nextTabVideos?.length > 0
      ? nextTabVideos
      : sectionData?.items;
  videoItems.forEach(item => {
    if (!item.msid && item.id) {
      item.msid = item.id;
    }
  });

  const getPlayerType = playerType => {
    switch (playerType) {
      case 'slike':
        return '24';
      case 'youtube':
        return '10';
      default:
        return playerType || '';
    }
  };

  const getSlikeIdAndPlayerIdFromMsid = msid => {
    const playerData = {};
    if (videoItems && Array.isArray(videoItems) && videoItems.length > 0) {
      const video = videoItems.find(item => item?.msid === msid);
      if (video) {
        playerData.slikeId = video.playerId;
        playerData.playerId = getPlayerType(video.playerType);
      }
    }
    return playerData;
  };

  const markPlaying = (data, autoPlayed = true) => {
    const playingVideoMsid = typeof data === 'object' ? data?.msid : data;
    const tempshareUrl = typeof data === 'object' ? data?.wu : '';
    const tempactiveVideo = videoItems.find(
      video => video.msid === playingVideoMsid,
    );
    // if (!activeVideo) return;
    setActiveVideo(tempactiveVideo);
    setSlikeNextVideoAutoPlayed(autoPlayed);
    setShareUrl(tempshareUrl);
  };

  const getNextVideosMsidArray = () =>
    videoItems &&
    Array.isArray(videoItems) &&
    videoItems.length > 0 &&
    videoItems.map(item => item.msid);

  const setNextVideo = data => {
    const nextVideosMsidArray = getNextVideosMsidArray();
    const oldMsid = data?.msid;
    const nextVideoIndex = nextVideosMsidArray.indexOf(oldMsid) + 1;
    const newMsid = nextVideosMsidArray[nextVideoIndex];
    const { slikeId, playerId } = getSlikeIdAndPlayerIdFromMsid(newMsid);
    addNextVideoMsid(newMsid, slikeId, playerId);
    markPlaying(newMsid);
  };

  const videoEventListener = (messageName, data) => {
    if (data?.[1] === 'VIDEOEND') {
      setNextVideo(activeVideo);
    }
  };

  const handleVideoClick = (event, clickedVideoItem, gaIndex = 1) => {
    event.preventDefault();
    markPlaying(clickedVideoItem, false);
    // if (window?.grx_module?.hitgrxPageviewReact) {
    //   window.grx_module.hitgrxPageviewReact(false, clickedVideoItem?.wu);
    // }
    if (sectionData?.ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: sectionData.ga4Type,
        category: 'story_click',
        story_no: gaIndex,
        msid: clickedVideoItem?.msid,
      });
    }
  };

  const fetchNavigation = async dataUrl => {
    if (!dataUrl) return;
    try {
      const data = await makeRequest.get(
        dataUrl,
        { isMobile },
        'skipfeedengine',
      );
      if (data?.data?.items?.length) {
        setNavigation(data.data.items);
      }
    } catch (error) {
      console.error('Error fetching navigation:', error);
    }
  };
  useEffect(
    () => {
      if (sectionData?.subSections?.dataUrl) {
        fetchNavigation(sectionData.subSections.dataUrl);
      }
    },
    [sectionData],
  );

  const handleLoadMore = () => {
    setShowAllVideos(true);
  };

  const onTabsChange = params => {
    setLoader(true);
    setActiveVideo({});
    const apiUrl = params?.clickedItem?.newdataUrl
      ? params?.clickedItem?.newdataUrl
      : `${UNIFIED_VIDEO_DOMAIN_SERVICE}?client=toi&pc=toi&dm=t&msid=${
          params?.clickedItem?.id
        }&pp=10&apiType=p`;
    // Fetch data and update state
    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        const filteredData =
          data?.items?.map((item, index) => ({
            msid: item?.msid || '',
            tn: item?.tn || '',
            wu: item?.wu || '',
            imageid: item?.imageid || '',
            hl: item?.hl || '',
            lpt: item?.lpt || '',
            syn: item?.syn || '',
            playerId: item?.playerId || '',
            createdTime: item?.createdTime || '',
            vw: item?.vw || '', // Use `??` to handle 0 values correctly
            du: item?.du || '',
            id: item?.id || '',
            gaIndex: index + 1,
          })) || [];
        setNextTabVideos(filteredData);
        setLoader(false);
      })
      .catch(error => console.error('Error fetching data:', error));
    // if (loadAjaxSectionData) {
    //   loadAjaxSectionData({ ...params, sectionId: sectionData.id });
    // }
  };

  const moreLink = sectionData.path ? sectionData.path : '/videos';

  return (
    <InViewObserver
      inViewCallback={() => {
        fetchNavigation(sectionData?.subSections?.dataUrl);
        analyticsWrapper('ga4', {
          event: 'user_shown',
          type: sectionData?.ga4Type || '',
          category: sectionData?.ga4Category || '',
        });
      }}
      viewMargin="300px 0px 300px 0px"
      className={s.inViewObserver}
    >
      <div
        className={`${s.videosSection} white_bg ${s[sectionData?.className]}`}
        id={sectionData?.jumplinkId || ''}
      >
        {sectionData?.border === 'top' && (
          <InterSectionBorder border={sectionData?.border} />
        )}
        <Listingheader
          headingname={sectionData.name}
          headingLink={sectionData.link || sectionData.path}
        >
          <HeaderTab subSections={navigation} onChangeCallback={onTabsChange} />
        </Listingheader>
        {!isMobile ? (
          <div className="grid_wrapper">
            <div className="col_l_7 col_m_8">
              {activeVideo && activeVideo.msid ? (
                <Video
                  msid={activeVideo.msid}
                  // videoClassName="phShimmer"
                  videoClassName={s.backgroundVideoImage}
                  videoClassInner={s.player_container_wrap}
                  autoplay
                  slikeNextVideoAutoPlayed={slikeNextVideoAutoPlayed}
                  // store={store}
                  allowDim={false}
                  slikeId={activeVideo.playerId}
                  playerType="24"
                  isUserPrime={isUserPrime}
                  source={
                    isEtimesVideo
                      ? 'ETimesVideoWidget'
                      : 'USNHP_MainVideoWidget'
                  }
                  outsideEventListener={videoEventListener}
                  shareUrl={shareUrl}
                  isVideoSkipAds={isVideoSkipAds}
                  tmplSource="videoshow"
                  metakeywords="Entertainment"
                />
              ) : (
                <>
                  {videoItems &&
                    Array.isArray(videoItems) &&
                    videoItems.length > 0 &&
                    videoItems?.[0] && (
                      <div
                        className={`${s.videowrapper}`}
                        onClick={event =>
                          handleVideoClick(
                            event,
                            videoItems?.[0],
                            videoItems?.[0]?.gaIndex,
                          )
                        }
                      >
                        <NewStoryCard
                          title={videoItems[0]?.hl || ''}
                          msid={videoItems[0]?.imageid || ''}
                          imagesize={videoItems[0]?.imagesize}
                          isBigHeading
                          key={videoItems[0].imageid || videoItems[0].hl} // Unique key
                          isLarge
                          cardType="card_2"
                          // wu={videoItems[0].wu || ''}
                          // syn={videoItems[0]?.syn}
                          gaIndex={videoItems[0]?.gaIndex}
                          ga4Type={sectionData?.ga4Type}
                          ga4Label={sectionData?.ga4Type}
                          videoTime={videoItems[0]?.du}
                          slikeId={videoItems[0]?.playerId}
                          iconClass="videoshowIcon"
                          createdTime={videoItems[0]?.createdTime}
                          showPlayIconAlso
                        />
                      </div>
                    )}
                </>
              )}
            </div>
            <div className={`col_l_5 col_m_4 ${className} ${s.scrollWrapper}`}>
              <div className={s.videoListWrapper}>
                <div className={`${s.videoList} scroll_visible`}>
                  {videoItems &&
                    Array.isArray(videoItems) &&
                    videoItems.length > 0 &&
                    videoItems?.map((item, index) => (
                      <div
                        className={s.videoListItem}
                        key={item.imageid || item.hl || index}
                        ref={videoListRef}
                      >
                        <div
                          onClick={event =>
                            handleVideoClick(event, item, item?.gaIndex)
                          }
                        >
                          <NewStoryCard
                            onClick={event =>
                              handleVideoClick(event, item, item?.gaIndex)
                            }
                            title={item.hl || ''}
                            msid={item.imageid || ''}
                            imagesize={item?.imagesize}
                            isBigHeading={false}
                            isLarge={false}
                            cardType="card_15"
                            gaIndex={item?.gaIndex}
                            ga4Type={sectionData?.ga4Type}
                            ga4Label={sectionData?.ga4Type}
                            videoTime={item?.du}
                            slikeId={item?.playerId}
                            iconClass="videoshowIcon"
                            createdTime={item?.createdTime}
                            isVideoActive={activeVideo?.msid === item?.msid}
                          />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={s.videoWrapper}>
            {activeVideo?.msid ? (
              <Video
                msid={activeVideo.msid}
                // videoClassName="phShimmer"
                videoClassName={s.backgroundVideoImage}
                videoClassInner={s.player_container_wrap}
                autoplay
                slikeNextVideoAutoPlayed={slikeNextVideoAutoPlayed}
                allowDim={false}
                slikeId={activeVideo.playerId}
                playerType="24"
                isUserPrime={isUserPrime}
                source={
                  isEtimesVideo ? 'ETimesVideoWidget' : 'USNHP_MainVideoWidget'
                }
                outsideEventListener={videoEventListener}
                shareUrl={shareUrl}
                isVideoSkipAds={isVideoSkipAds}
                tmplSource="videoshow"
                metakeywords="Entertainment"
              />
            ) : (
              <>
                {videoItems &&
                  Array.isArray(videoItems) &&
                  videoItems.length > 0 &&
                  videoItems?.[0] && (
                    <div
                      className={`${s.videowrapper}`}
                      onClick={event =>
                        handleVideoClick(
                          event,
                          videoItems?.[0],
                          videoItems?.[0]?.gaIndex,
                        )
                      }
                    >
                      <NewStoryMobileCard
                        title={videoItems[0].hl || ''}
                        msid={
                          videoItems[0].imageid || videoItems[0].image?.id || ''
                        }
                        isBigHeading
                        key={videoItems[0].imageid || videoItems[0].hl}
                        isLarge={false}
                        cardType="card_23"
                        // wu={videoItems[0].wu || ''}
                        videoTime={videoItems[0]?.du}
                        slikeId={videoItems[0]?.playerId}
                        iconClass="videoshowIcon"
                        createdTime={videoItems[0]?.createdTime}
                        // syn={videoItems[0]?.syn}
                        gaIndex={videoItems[0]?.gaIndex}
                        ga4Type={sectionData?.ga4Type}
                        ga4Label={sectionData?.ga4Type}
                        showPlayIconAlso
                      />
                    </div>
                  )}
              </>
            )}
            <div className={s.videoListItem}>
              {videoItems &&
                Array.isArray(videoItems) &&
                videoItems.length > 0 &&
                videoItems
                  .slice(1, showAllVideos ? videoItems.length : 4)
                  .map(item => (
                    <div
                      onClick={event =>
                        handleVideoClick(event, item, item?.gaIndex)
                      }
                    >
                      <NewStoryMobileCard
                        key={item.imageid || item.hl}
                        title={item.hl || ''}
                        msid={item.imageid || item.image.id || ''}
                        isBigHeading={false}
                        isLarge={false}
                        cardType="card_7_1"
                        // wu={item.wu || ''}
                        videoTime={item?.du}
                        slikeId={item?.playerId}
                        iconClass="videoshowIcon"
                        createdTime={item?.createdTime}
                        gaIndex={item?.gaIndex}
                        ga4Type={sectionData?.ga4Type}
                        ga4Label={sectionData?.ga4Type}
                        isVideoActive={activeVideo?.msid === item?.msid}
                      />
                    </div>
                  ))}
            </div>
            {!showAllVideos && (
              <Morebtn
                absoluteMoreText={
                  showAllVideos ? 'explore more videos' : 'more videos'
                }
                moreLink={showAllVideos && '/videos'}
                isNoLink={!showAllVideos}
                onClick={!showAllVideos && handleLoadMore}
              />
            )}
          </div>
        )}
        {showAllVideos && (
          <Morebtn
            absoluteMoreText={
              showAllVideos ? 'explore more videos' : 'load more'
            }
            moreLink={showAllVideos && moreLink}
            onClick={!showAllVideos && handleLoadMore}
          />
        )}
        {showLoader && <LoaderSpinner />}
      </div>
    </InViewObserver>
  );
};

const mapStateToProps = state => ({
  showVideoSectionLoader:
    (state.homepage && state.homepage.showVideoSectionLoader) ||
    (state.homepage_us && state.homepage_us.showVideoSectionLoader),
  isUserPrime: state.isPrime,
  isMobile: state.isMobile,
});

const mapDispatchToProps = dispatch => ({
  addNextVideoMsid: (msidForNextVideo, slikeId, playerId) => {
    dispatch(addNextVideoMsid(msidForNextVideo, slikeId, playerId));
  },
});

VideoLayout.propTypes = {
  sectionData: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        hl: PropTypes.string,
        image: PropTypes.shape({}),
        du: PropTypes.string,
        imageid: PropTypes.string,
        wu: PropTypes.string,
      }),
    ),
  }).isRequired,
  addNextVideoMsid: PropTypes.func.isRequired,
  className: PropTypes.string,
  isUserPrime: PropTypes.bool,
  isVideoSkipAds: PropTypes.bool,
  isMobile: PropTypes.bool,
};

VideoLayout.defaultProps = {
  className: '',
  isUserPrime: false,
  isVideoSkipAds: false,
  isMobile: false,
};

VideoLayout.contextTypes = {
  store: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoLayout);
